module.exports = __webpack_public_path__ + "static/media/logo.ebb985bd.svg";